export default __webpack_public_path__ + "static/media/5.6caad96f.jpg";